// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.3 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --spacing: 0.25rem;
    --container-xl: 36rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-wide: 0.025em;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --ease-in: cubic-bezier(0.4, 0, 1, 1);
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --color-dark-grey: #2c3133;
    --color-blue: #29abe2;
    --color-light-blue: rgba(41, 171, 226, 0.1);
    --color-catskill-white: #e9eef6;
    --spacing-navbar-height: 60px;
  }
}
@layer utilities {
  .pointer-events-auto\\! {
    pointer-events: auto !important;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .pointer-events-none\\! {
    pointer-events: none !important;
  }
  .collapse {
    visibility: collapse;
  }
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .relative\\! {
    position: relative !important;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1\\/2 {
    top: calc(1/2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-auto {
    top: auto;
  }
  .top-navbar-height {
    top: 60px;
  }
  .-right-\\[0\\.43px\\] {
    right: calc(0.43px * -1);
  }
  .-right-\\[1px\\] {
    right: calc(1px * -1);
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .-bottom-\\[1\\.32px\\] {
    bottom: calc(1.32px * -1);
  }
  .-bottom-\\[1px\\] {
    bottom: calc(1px * -1);
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-2\\! {
    left: calc(var(--spacing) * 2) !important;
  }
  .left-3 {
    left: calc(var(--spacing) * 3);
  }
  .isolate {
    isolation: isolate;
  }
  .z-1 {
    z-index: 1;
  }
  .z-2 {
    z-index: 2;
  }
  .z-10 {
    z-index: 10;
  }
  .z-35 {
    z-index: 35;
  }
  .z-99 {
    z-index: 99;
  }
  .col-1 {
    grid-column: 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .row-1 {
    grid-row: 1;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .m-0\\! {
    margin: calc(var(--spacing) * 0) !important;
  }
  .m-auto {
    margin: auto;
  }
  .mx-0 {
    margin-inline: calc(var(--spacing) * 0);
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-\\[17px\\] {
    margin-inline: 17px;
  }
  .my-0 {
    margin-block: calc(var(--spacing) * 0);
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1);
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .my-4\\.5 {
    margin-block: calc(var(--spacing) * 4.5);
  }
  .-mt-3 {
    margin-top: calc(var(--spacing) * -3);
  }
  .-mt-6\\! {
    margin-top: calc(var(--spacing) * -6) !important;
  }
  .-mt-\\[17\\.5px\\] {
    margin-top: calc(17.5px * -1);
  }
  .mt-0 {
    margin-top: calc(var(--spacing) * 0);
  }
  .mt-0\\! {
    margin-top: calc(var(--spacing) * 0) !important;
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-1\\! {
    margin-top: calc(var(--spacing) * 1) !important;
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-\\[3px\\] {
    margin-top: 3px;
  }
  .mt-auto {
    margin-top: auto;
  }
  .mr-0 {
    margin-right: calc(var(--spacing) * 0);
  }
  .mr-0\\! {
    margin-right: calc(var(--spacing) * 0) !important;
  }
  .mr-1 {
    margin-right: calc(var(--spacing) * 1);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-2\\! {
    margin-right: calc(var(--spacing) * 2) !important;
  }
  .mr-\\[5\\.6px\\] {
    margin-right: 5.6px;
  }
  .mr-\\[10\\.7px\\] {
    margin-right: 10.7px;
  }
  .mr-\\[35px\\] {
    margin-right: 35px;
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-0\\! {
    margin-bottom: calc(var(--spacing) * 0) !important;
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .ml-0 {
    margin-left: calc(var(--spacing) * 0);
  }
  .ml-0\\! {
    margin-left: calc(var(--spacing) * 0) !important;
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-2\\.5 {
    margin-left: calc(var(--spacing) * 2.5);
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4);
  }
  .ml-12 {
    margin-left: calc(var(--spacing) * 12);
  }
  .ml-\\[7px\\] {
    margin-left: 7px;
  }
  .ml-auto {
    margin-left: auto;
  }
  .ml-auto\\! {
    margin-left: auto !important;
  }
  .box-border {
    box-sizing: border-box;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .size-3 {
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
  }
  .size-4 {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .size-6 {
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
  }
  .size-7 {
    width: calc(var(--spacing) * 7);
    height: calc(var(--spacing) * 7);
  }
  .size-8 {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
  }
  .size-10\\! {
    width: calc(var(--spacing) * 10) !important;
    height: calc(var(--spacing) * 10) !important;
  }
  .size-100 {
    width: calc(var(--spacing) * 100);
    height: calc(var(--spacing) * 100);
  }
  .size-\\[1\\.5625rem\\] {
    width: 1.5625rem;
    height: 1.5625rem;
  }
  .size-\\[25px\\] {
    width: 25px;
    height: 25px;
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .\\!h-4 {
    height: calc(var(--spacing) * 4) !important;
  }
  .\\!h-\\[17px\\] {
    height: 17px !important;
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-6\\! {
    height: calc(var(--spacing) * 6) !important;
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-10\\! {
    height: calc(var(--spacing) * 10) !important;
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-\\[1px\\] {
    height: 1px;
  }
  .h-\\[10\\.82px\\] {
    height: 10.82px;
  }
  .h-\\[11\\.2px\\] {
    height: 11.2px;
  }
  .h-\\[13\\.9px\\] {
    height: 13.9px;
  }
  .h-\\[25px\\] {
    height: 25px;
  }
  .h-\\[29px\\]\\! {
    height: 29px !important;
  }
  .h-\\[33px\\] {
    height: 33px;
  }
  .h-\\[calc\\(100vh-120px\\)\\]\\! {
    height: calc(100vh - 120px) !important;
  }
  .h-auto {
    height: auto;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .h-screen-chabot-height {
    height: calc(100vh - var(--spacing-navbar-height) - 64px);
  }
  .h-screen-navbar-height {
    height: calc(100vh - var(--spacing-navbar-height));
  }
  .max-h-100 {
    max-height: calc(var(--spacing) * 100);
  }
  .max-h-110 {
    max-height: calc(var(--spacing) * 110);
  }
  .min-h-4 {
    min-height: calc(var(--spacing) * 4);
  }
  .min-h-37 {
    min-height: calc(var(--spacing) * 37);
  }
  .min-h-\\[25px\\] {
    min-height: 25px;
  }
  .w-0\\.5 {
    width: calc(var(--spacing) * 0.5);
  }
  .w-1\\/2 {
    width: calc(1/2 * 100%);
  }
  .w-3\\/4 {
    width: calc(3/4 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-54 {
    width: calc(var(--spacing) * 54);
  }
  .w-59 {
    width: calc(var(--spacing) * 59);
  }
  .w-84 {
    width: calc(var(--spacing) * 84);
  }
  .w-100 {
    width: calc(var(--spacing) * 100);
  }
  .w-125 {
    width: calc(var(--spacing) * 125);
  }
  .w-\\[40\\%\\] {
    width: 40%;
  }
  .w-\\[47px\\] {
    width: 47px;
  }
  .w-\\[48px\\] {
    width: 48px;
  }
  .w-\\[60\\%\\] {
    width: 60%;
  }
  .w-\\[229px\\] {
    width: 229px;
  }
  .w-\\[400px\\] {
    width: 400px;
  }
  .w-\\[404px\\] {
    width: 404px;
  }
  .w-\\[700px\\] {
    width: 700px;
  }
  .w-\\[calc\\(100\\%\\+2px\\)\\] {
    width: calc(100% + 2px);
  }
  .w-\\[calc\\(100\\%-theme\\(space\\.4\\)\\)\\] {
    width: calc(100% - 1rem);
  }
  .w-\\[calc\\(100\\%-var\\(--spacing\\)\\*16\\)\\] {
    width: calc(100% - var(--spacing) * 16);
  }
  .w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-px {
    width: 1px;
  }
  .w-sidebar-closed-width {
    width: 48px;
  }
  .w-sidebar-opened-width {
    width: 230px;
  }
  .max-w-84 {
    max-width: calc(var(--spacing) * 84);
  }
  .max-w-\\[70\\%\\] {
    max-width: 70%;
  }
  .max-w-\\[80\\%\\] {
    max-width: 80%;
  }
  .max-w-\\[100\\%\\] {
    max-width: 100%;
  }
  .max-w-full {
    max-width: 100%;
  }
  .min-w-4 {
    min-width: calc(var(--spacing) * 4);
  }
  .min-w-8 {
    min-width: calc(var(--spacing) * 8);
  }
  .min-w-33 {
    min-width: calc(var(--spacing) * 33);
  }
  .min-w-40 {
    min-width: calc(var(--spacing) * 40);
  }
  .min-w-44 {
    min-width: calc(var(--spacing) * 44);
  }
  .min-w-84 {
    min-width: calc(var(--spacing) * 84);
  }
  .min-w-\\[7\\.5rem\\] {
    min-width: 7.5rem;
  }
  .min-w-\\[163px\\] {
    min-width: 163px;
  }
  .min-w-\\[190px\\] {
    min-width: 190px;
  }
  .min-w-\\[279px\\] {
    min-width: 279px;
  }
  .min-w-auto {
    min-width: auto;
  }
  .min-w-xl\\! {
    min-width: var(--container-xl) !important;
  }
  .flex-1 {
    flex: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .border-spacing-0 {
    --tw-border-spacing-x: calc(var(--spacing) * 0);
    --tw-border-spacing-y: calc(var(--spacing) * 0);
    border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
  }
  .-translate-x-full {
    --tw-translate-x: -100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-\\[calc\\(-100\\%\\+24px\\)\\] {
    --tw-translate-x: calc(-100% + 24px);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[-100\\%\\] {
    --tw-translate-y: -100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-90 {
    --tw-scale-x: 90%;
    --tw-scale-y: 90%;
    --tw-scale-z: 90%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .-rotate-90 {
    rotate: calc(90deg * -1);
  }
  .rotate-90 {
    rotate: 90deg;
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .transform {
    transform: var(--tw-rotate-x) var(--tw-rotate-y) var(--tw-rotate-z) var(--tw-skew-x) var(--tw-skew-y);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-shake {
    animation: shake 0.5s;
  }
  .cursor-auto {
    cursor: auto;
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-not-allowed\\! {
    cursor: not-allowed !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-progress {
    cursor: progress;
  }
  .resize {
    resize: both;
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-around {
    justify-content: space-around;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-center\\! {
    justify-content: center !important;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .gap-0 {
    gap: calc(var(--spacing) * 0);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-10 {
    gap: calc(var(--spacing) * 10);
  }
  .gap-\\[3px\\] {
    gap: 3px;
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .self-end {
    align-self: flex-end;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-visible\\! {
    overflow: visible !important;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-y-hidden {
    overflow-y: hidden;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-\\[0\\.5px\\] {
    border-radius: 0.5px;
  }
  .rounded-\\[1px\\] {
    border-radius: 1px;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-full\\! {
    border-radius: calc(infinity * 1px) !important;
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none\\! {
    border-radius: 0 !important;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-xl\\! {
    border-radius: var(--radius-xl) !important;
  }
  .rounded-tl-none\\! {
    border-top-left-radius: 0 !important;
  }
  .rounded-tl-sm\\! {
    border-top-left-radius: var(--radius-sm) !important;
  }
  .rounded-b-sm {
    border-bottom-right-radius: var(--radius-sm);
    border-bottom-left-radius: var(--radius-sm);
  }
  .rounded-b-sm\\! {
    border-bottom-right-radius: var(--radius-sm) !important;
    border-bottom-left-radius: var(--radius-sm) !important;
  }
  .rounded-br-sm\\! {
    border-bottom-right-radius: var(--radius-sm) !important;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border\\! {
    border-style: var(--tw-border-style) !important;
    border-width: 1px !important;
  }
  .border-1 {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-l-0 {
    border-left-style: var(--tw-border-style);
    border-left-width: 0px;
  }
  .border-l-\\[2px\\] {
    border-left-style: var(--tw-border-style);
    border-left-width: 2px;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-none\\! {
    --tw-border-style: none !important;
    border-style: none !important;
  }
  .border-\\[\\#e3e6e7\\] {
    border-color: #e3e6e7;
  }
  .border-bay-of-many {
    border-color: #2d348d;
  }
  .border-blue {
    border-color: #29abe2;
  }
  .border-blue\\! {
    border-color: #29abe2 !important;
  }
  .border-carrot-orange {
    border-color: #ef942a;
  }
  .border-geyser {
    border-color: #dfe3e8;
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-gray-300 {
    border-color: var(--color-gray-300);
  }
  .border-gray-chateau {
    border-color: #a8abae;
  }
  .border-gray-chateau\\! {
    border-color: #a8abae !important;
  }
  .border-grey {
    border-color: #c6cdd0;
  }
  .border-hawkes-blue {
    border-color: #dee0fc;
  }
  .border-jacksons-purple {
    border-color: #2e3487;
  }
  .border-light-grey {
    border-color: #eaebf0;
  }
  .border-medium-purple {
    border-color: #7d57dd;
  }
  .border-separator-color {
    border-color: rgba(171, 180, 192, 0.2);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-l-blue {
    border-left-color: #29abe2;
  }
  .border-l-carrot-orange {
    border-left-color: #ef942a;
  }
  .border-l-jacksons-purple {
    border-left-color: #2e3487;
  }
  .border-l-medium-purple {
    border-left-color: #7d57dd;
  }
  .\\!bg-transparent {
    background-color: transparent !important;
  }
  .bg-\\[\\#29abe2\\]\\/10 {
    background-color: color-mix(in oklab, #29abe2 10%, transparent);
  }
  .bg-\\[\\#ececec\\] {
    background-color: #ececec;
  }
  .bg-\\[unset\\]\\! {
    background-color: unset !important;
  }
  .bg-alto {
    background-color: #dfdfdf;
  }
  .bg-bay-of-many {
    background-color: #2d348d;
  }
  .bg-blue {
    background-color: #29abe2;
  }
  .bg-blue\\! {
    background-color: #29abe2 !important;
  }
  .bg-blue-chalk {
    background-color: #f0eaff;
  }
  .bg-blue-chalk\\! {
    background-color: #f0eaff !important;
  }
  .bg-bombay {
    background-color: #b1b6b9;
  }
  .bg-bridal-heath {
    background-color: #fff8f1;
  }
  .bg-carrot-orange {
    background-color: #ef942a;
  }
  .bg-curious-blue\\/10 {
    background-color: color-mix(in oklab, #29abe2 10%, transparent);
  }
  .bg-foam {
    background-color: #f1fbfe;
  }
  .bg-fog {
    background-color: #d6d9ff;
  }
  .bg-gallery {
    background-color: #ebebeb;
  }
  .bg-geyser {
    background-color: #dfe3e8;
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-200 {
    background-color: var(--color-gray-200);
  }
  .bg-gray-300 {
    background-color: var(--color-gray-300);
  }
  .bg-gray-chateau {
    background-color: #a8abae;
  }
  .bg-green {
    background-color: #75d052;
  }
  .bg-grey {
    background-color: #c6cdd0;
  }
  .bg-hawkes-blue {
    background-color: #dee0fc;
  }
  .bg-hot-cinnamon\\/10 {
    background-color: color-mix(in oklab, #e26f29 10%, transparent);
  }
  .bg-jacksons-purple {
    background-color: #2e3487;
  }
  .bg-jacksons-purple\\/10 {
    background-color: color-mix(in oklab, #2e3487 10%, transparent);
  }
  .bg-light-grey {
    background-color: #eaebf0;
  }
  .bg-loblolly {
    background-color: #c7cdd0;
  }
  .bg-medium-purple\\/10 {
    background-color: color-mix(in oklab, #7d57dd 10%, transparent);
  }
  .bg-mercury {
    background-color: #e6e6e6;
  }
  .bg-mine-shaft {
    background-color: #393939;
  }
  .bg-porcelain {
    background-color: #edeff0;
  }
  .bg-purple-100 {
    background-color: #f0eaff;
  }
  .bg-purple-200 {
    background-color: #dcceff;
  }
  .bg-purple-500 {
    background-color: #7d57dd;
  }
  .bg-red {
    background-color: #f54c26;
  }
  .bg-scampi {
    background-color: #6269a6;
  }
  .bg-selago {
    background-color: #ecebfb;
  }
  .bg-serenade {
    background-color: #fff5ea;
  }
  .bg-tequila {
    background-color: #ffe7cc;
  }
  .bg-titan-white {
    background-color: #ebecfe;
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white {
    background-color: #fff;
  }
  .bg-wild-sand {
    background-color: #f4f3f3;
  }
  .fill-current {
    fill: currentcolor;
  }
  .\\!p-0 {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-0\\! {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-2\\.5 {
    padding: calc(var(--spacing) * 2.5);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-\\[0px_16px_0px_11\\.8px\\] {
    padding: 0px 16px 0px 11.8px;
  }
  .p-\\[3px\\] {
    padding: 3px;
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0);
  }
  .px-0\\.5 {
    padding-inline: calc(var(--spacing) * 0.5);
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-\\[\\.1rem\\] {
    padding-inline: .1rem;
  }
  .px-\\[2px\\] {
    padding-inline: 2px;
  }
  .px-\\[6\\.4px\\] {
    padding-inline: 6.4px;
  }
  .px-\\[10\\.1px\\] {
    padding-inline: 10.1px;
  }
  .py-0 {
    padding-block: calc(var(--spacing) * 0);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-\\[8px\\] {
    padding-block: 8px;
  }
  .pt-0\\! {
    padding-top: calc(var(--spacing) * 0) !important;
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4);
  }
  .pr-5 {
    padding-right: calc(var(--spacing) * 5);
  }
  .pr-10 {
    padding-right: calc(var(--spacing) * 10);
  }
  .pb-1 {
    padding-bottom: calc(var(--spacing) * 1);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-4\\! {
    padding-bottom: calc(var(--spacing) * 4) !important;
  }
  .pl-0 {
    padding-left: calc(var(--spacing) * 0);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-8\\! {
    padding-left: calc(var(--spacing) * 8) !important;
  }
  .pl-9 {
    padding-left: calc(var(--spacing) * 9);
  }
  .pl-10 {
    padding-left: calc(var(--spacing) * 10);
  }
  .pl-12 {
    padding-left: calc(var(--spacing) * 12);
  }
  .pl-\\[11px\\] {
    padding-left: 11px;
  }
  .pl-\\[20\\.8px\\] {
    padding-left: 20.8px;
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-xs\\! {
    font-size: var(--text-xs) !important;
    line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
  }
  .text-\\[8px\\] {
    font-size: 8px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[22px\\] {
    font-size: 22px;
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .leading-\\[1\\] {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-\\[15px\\] {
    --tw-leading: 15px;
    line-height: 15px;
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-bold\\! {
    --tw-font-weight: var(--font-weight-bold) !important;
    font-weight: var(--font-weight-bold) !important;
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-normal\\! {
    --tw-font-weight: var(--font-weight-normal) !important;
    font-weight: var(--font-weight-normal) !important;
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .text-nowrap {
    text-wrap: nowrap;
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .text-ellipsis {
    text-overflow: ellipsis;
  }
  .whitespace-normal\\! {
    white-space: normal !important;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .text-\\[\\#2c3133\\] {
    color: #2c3133;
  }
  .text-\\[\\#9eabb0\\] {
    color: #9eabb0;
  }
  .text-amethyst {
    color: #a146d3;
  }
  .text-amethyst\\! {
    color: #a146d3 !important;
  }
  .text-bay-of-many {
    color: #2d348d;
  }
  .text-bay-of-many\\! {
    color: #2d348d !important;
  }
  .text-black {
    color: #000;
  }
  .text-black\\! {
    color: #000 !important;
  }
  .text-blue {
    color: #29abe2;
  }
  .text-blue-chalk {
    color: #f0eaff;
  }
  .text-cadet-blue {
    color: #adb4bf;
  }
  .text-carrot-orange {
    color: #ef942a;
  }
  .text-chelsea-gem {
    color: #9d5500;
  }
  .text-cod-gray {
    color: #0b0b0b;
  }
  .text-dark-grey {
    color: #2c3133;
  }
  .text-disabled-grey {
    color: #818e94;
  }
  .text-dove-gray {
    color: #6c6c6c;
  }
  .text-dove-gray\\! {
    color: #6c6c6c !important;
  }
  .text-flush-mahogany {
    color: #d14646;
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-800 {
    color: var(--color-gray-800);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-gray-chateau {
    color: #a8abae;
  }
  .text-green {
    color: #75d052;
  }
  .text-grey {
    color: #c6cdd0;
  }
  .text-hawkes-blue {
    color: #dee0fc;
  }
  .text-hit-gray {
    color: #9dabb0;
  }
  .text-inherit {
    color: inherit;
  }
  .text-jacksons-purple {
    color: #2e3487;
  }
  .text-loblolly {
    color: #c7cdd0;
  }
  .text-mango-tango {
    color: #e57208;
  }
  .text-medium-purple {
    color: #7d57dd;
  }
  .text-mine-shaft {
    color: #393939;
  }
  .text-navy {
    color: #303842;
  }
  .text-ochre {
    color: #c97c21;
  }
  .text-oslo-gray {
    color: #7f888a;
  }
  .text-oslo-gray2 {
    color: #818e94;
  }
  .text-outer-space {
    color: #2c3133;
  }
  .text-purple-500 {
    color: #7d57dd;
  }
  .text-purple-700 {
    color: #4c26ab;
  }
  .text-red {
    color: #f54c26;
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-rolling-stone {
    color: #71777a;
  }
  .text-selago {
    color: #ecebfb;
  }
  .text-serenade {
    color: #fff5ea;
  }
  .text-shuttle-gray {
    color: #586165;
  }
  .text-shuttle-gray2 {
    color: #566166;
  }
  .text-slightly-darker-blue {
    color: #272a80;
  }
  .text-text-grey {
    color: #566166;
  }
  .text-white {
    color: #fff;
  }
  .text-white\\! {
    color: #fff !important;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .normal-case {
    text-transform: none;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .no-underline {
    text-decoration-line: none;
  }
  .underline {
    text-decoration-line: underline;
  }
  .decoration-0\\! {
    text-decoration-thickness: 0px !important;
  }
  .placeholder-gray-400 {
    &::-moz-placeholder {
      color: var(--color-gray-400);
    }
    &::placeholder {
      color: var(--color-gray-400);
    }
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-80 {
    opacity: 80%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow-\\[0\\.1875rem_0\\.1875rem_0\\.625rem_0_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-shadow: 0.1875rem 0.1875rem 0.625rem 0 var(--tw-shadow-color, rgba(0,0,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-popup {
    --tw-shadow: 0px 1px 10px 0px var(--tw-shadow-color, #00000040);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-popup\\! {
    --tw-shadow: 0px 1px 10px 0px var(--tw-shadow-color, #00000040) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-blue {
    --tw-ring-color: #29abe2;
  }
  .ring-carrot-orange {
    --tw-ring-color: #ef942a;
  }
  .ring-cinnabar {
    --tw-ring-color: #e35837;
  }
  .ring-jacksons-purple {
    --tw-ring-color: #2e3487;
  }
  .ring-medium-purple {
    --tw-ring-color: #7d57dd;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .grayscale {
    --tw-grayscale: grayscale(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .grayscale-50 {
    --tw-grayscale: grayscale(50%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .grayscale-\\[100\\%\\] {
    --tw-grayscale: grayscale(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[margin\\] {
    transition-property: margin;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[opacity\\] {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[width\\] {
    transition-property: width;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all\\! {
    transition-property: all !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-75 {
    --tw-duration: 75ms;
    transition-duration: 75ms;
  }
  .duration-100 {
    --tw-duration: 100ms;
    transition-duration: 100ms;
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-300\\! {
    --tw-duration: 300ms !important;
    transition-duration: 300ms !important;
  }
  .ease-in {
    --tw-ease: var(--ease-in);
    transition-timing-function: var(--ease-in);
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-all {
    -webkit-user-select: all;
    -moz-user-select: all;
         user-select: all;
  }
  .select-none {
    -webkit-user-select: none;
    -moz-user-select: none;
         user-select: none;
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .first\\:rounded-l-sm {
    &:first-child {
      border-top-left-radius: var(--radius-sm);
      border-bottom-left-radius: var(--radius-sm);
    }
  }
  .first\\:border-r-0 {
    &:first-child {
      border-right-style: var(--tw-border-style);
      border-right-width: 0px;
    }
  }
  .first\\:pl-4 {
    &:first-child {
      padding-left: calc(var(--spacing) * 4);
    }
  }
  .last\\:rounded-r-sm {
    &:last-child {
      border-top-right-radius: var(--radius-sm);
      border-bottom-right-radius: var(--radius-sm);
    }
  }
  .last\\:border-l-0 {
    &:last-child {
      border-left-style: var(--tw-border-style);
      border-left-width: 0px;
    }
  }
  .odd\\:bg-black-squeeze {
    &:nth-child(odd) {
      background-color: #f4f8fb;
    }
  }
  .odd\\:bg-fantasy {
    &:nth-child(odd) {
      background-color: #fbf8f4;
    }
  }
  .odd\\:bg-purple-50 {
    &:nth-child(odd) {
      background-color: #f7f4fb;
    }
  }
  .odd\\:bg-titan-white {
    &:nth-child(odd) {
      background-color: #ebecfe;
    }
  }
  .hover\\:border-alto {
    &:hover {
      @media (hover: hover) {
        border-color: #dfdfdf;
      }
    }
  }
  .hover\\:border-gray-300 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-gray-300);
      }
    }
  }
  .hover\\:bg-alto {
    &:hover {
      @media (hover: hover) {
        background-color: #dfdfdf;
      }
    }
  }
  .hover\\:bg-gray-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-100);
      }
    }
  }
  .hover\\:bg-transparent {
    &:hover {
      @media (hover: hover) {
        background-color: transparent;
      }
    }
  }
  .hover\\:text-black {
    &:hover {
      @media (hover: hover) {
        color: #000;
      }
    }
  }
  .hover\\:text-gray-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-600);
      }
    }
  }
  .hover\\:text-gray-900 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-900);
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .focus\\:border-blue-500 {
    &:focus {
      border-color: var(--color-blue-500);
    }
  }
  .focus\\:ring-1 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .active\\:text-inherit {
    &:active {
      color: inherit;
    }
  }
  .hover\\:\\[\\&_\\.favorite-icon\\]\\:ml-\\[calc\\(100\\%-12px\\)\\] {
    &:hover {
      @media (hover: hover) {
        & .favorite-icon {
          margin-left: calc(100% - 12px);
        }
      }
    }
  }
  .\\[\\&_\\.product-favorite-button\\]\\:flex\\! {
    & .product-favorite-button {
      display: flex !important;
    }
  }
  .\\[\\&_\\.product-favorite-button\\]\\:hidden\\! {
    & .product-favorite-button {
      display: none !important;
    }
  }
}
@layer base {
  * {
    font-family: 'Avenir Next', sans-serif;
  }
}
@property --tw-border-spacing-x {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-spacing-y {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
  initial-value: rotateX(0);
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
  initial-value: rotateY(0);
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
  initial-value: rotateZ(0);
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
  initial-value: skewX(0);
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
  initial-value: skewY(0);
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes shake {
  0%,
    100% {
    transform: translateX(0);
  }
  10%,
    30%,
    50%,
    70%,
    90% {
    transform: translateX(-4px);
  }
  20%,
    40%,
    60%,
    80% {
    transform: translateX(4px);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-spacing-x: 0;
      --tw-border-spacing-y: 0;
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: rotateX(0);
      --tw-rotate-y: rotateY(0);
      --tw-rotate-z: rotateZ(0);
      --tw-skew-x: skewX(0);
      --tw-skew-y: skewY(0);
      --tw-space-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/tailwind.css"],"names":[],"mappings":"AAAA,gEA8MA;AA9MA,iBA8MA;AA9MA,yCA8MA;AA9MA;EAAA;IAAA,0CA8MA;IA9MA,4CA8MA;IA9MA,2CA8MA;IA9MA,4CA8MA;IA9MA,4CA8MA;IA9MA,2CA8MA;IA9MA,4CA8MA;IA9MA,4CA8MA;IA9MA,2CA8MA;IA9MA,4CA8MA;IA9MA,4CA8MA;IA9MA,0CA8MA;IA9MA,kBA8MA;IA9MA,qBA8MA;IA9MA,kBA8MA;IA9MA,sCA8MA;IA9MA,mBA8MA;IA9MA,0CA8MA;IA9MA,iBA8MA;IA9MA,uCA8MA;IA9MA,kBA8MA;IA9MA,yCA8MA;IA9MA,yBA8MA;IA9MA,yBA8MA;IA9MA,2BA8MA;IA9MA,uBA8MA;IA9MA,wBA8MA;IA9MA,oBA8MA;IA9MA,qBA8MA;IA9MA,mBA8MA;IA9MA,oBA8MA;IA9MA,qCA8MA;IA9MA,sCA8MA;IA9MA,2CA8MA;IA9MA,+DA8MA;IA9MA,oCA8MA;IA9MA,kEA8MA;IA9MA,0BA8MA;IA9MA,qBA8MA;IA9MA,2CA8MA;IA9MA,+BA8MA;IA9MA,6BA8MA;EAAA;AAAA;AA9MA;EAAA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,SA8MA;EAAA;EA9MA;IAAA,SA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,8BA8MA;EAAA;EA9MA;IAAA,yCA8MA;EAAA;EA9MA;IAAA,8BA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,UA8MA;EAAA;EA9MA;IAAA,UA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,WA8MA;IA9MA;MAAA,gBA8MA;IAAA;IA9MA;MAAA,gBA8MA;IAAA;IA9MA;MAAA,gBA8MA;IAAA;IA9MA;MAAA,gBA8MA;IAAA;IA9MA;MAAA,gBA8MA;IAAA;EAAA;EA9MA;IAAA,2CA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,gDA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,+CA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,+CA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,iDA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,iDA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,kDA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,gDA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,iBA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,iBA8MA;EAAA;EA9MA;IAAA,aA8MA;EAAA;EA9MA;IAAA,aA8MA;EAAA;EA9MA;IAAA,aA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,gCA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,gCA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,gCA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,gCA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,gCA8MA;EAAA;EA9MA;IAAA,2CA8MA;IA9MA,4CA8MA;EAAA;EA9MA;IAAA,iCA8MA;IA9MA,kCA8MA;EAAA;EA9MA;IAAA,gBA8MA;IA9MA,iBA8MA;EAAA;EA9MA;IAAA,WA8MA;IA9MA,YA8MA;EAAA;EA9MA;IAAA,WA8MA;IA9MA,YA8MA;EAAA;EA9MA;IAAA,2CA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,2CA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,4CA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,yDA8MA;EAAA;EA9MA;IAAA,kDA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,UA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,UA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uBA8MA;IA9MA,kBA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,UA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,mCA8MA;EAAA;EA9MA;IAAA,mCA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,iBA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,yCA8MA;EAAA;EA9MA;IAAA,OA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,+CA8MA;IA9MA,+CA8MA;IA9MA,qEA8MA;EAAA;EA9MA;IAAA,uBA8MA;IA9MA,sDA8MA;EAAA;EA9MA;IAAA,oCA8MA;IA9MA,sDA8MA;EAAA;EA9MA;IAAA,6CA8MA;IA9MA,sDA8MA;EAAA;EA9MA;IAAA,uBA8MA;IA9MA,sDA8MA;EAAA;EA9MA;IAAA,iBA8MA;IA9MA,iBA8MA;IA9MA,iBA8MA;IA9MA,0CA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,aA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,qGA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,8BA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,gDA8MA;EAAA;EA9MA;IAAA,gDA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,iBA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,8BA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,kCA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,8BA8MA;EAAA;EA9MA;IAAA,QA8MA;EAAA;EA9MA;IAAA;MAAA,uBA8MA;MA9MA,8EA8MA;MA9MA,sFA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,uBA8MA;MA9MA,8EA8MA;MA9MA,sFA8MA;IAAA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,gBA8MA;IA9MA,uBA8MA;IA9MA,mBA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,iBA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,mCA8MA;EAAA;EA9MA;IAAA,8CA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,2BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,0CA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,mDA8MA;EAAA;EA9MA;IAAA,4CA8MA;IA9MA,2CA8MA;EAAA;EA9MA;IAAA,uDA8MA;IA9MA,sDA8MA;EAAA;EA9MA;IAAA,uDA8MA;EAAA;EA9MA;IAAA,oCA8MA;IA9MA,iBA8MA;EAAA;EA9MA;IAAA,+CA8MA;IA9MA,4BA8MA;EAAA;EA9MA;IAAA,oCA8MA;IA9MA,iBA8MA;EAAA;EA9MA;IAAA,wCA8MA;IA9MA,qBA8MA;EAAA;EA9MA;IAAA,0CA8MA;IA9MA,uBA8MA;EAAA;EA9MA;IAAA,2CA8MA;IA9MA,wBA8MA;EAAA;EA9MA;IAAA,yCA8MA;IA9MA,sBA8MA;EAAA;EA9MA;IAAA,yCA8MA;IA9MA,sBA8MA;EAAA;EA9MA;IAAA,uBA8MA;IA9MA,kBA8MA;EAAA;EA9MA;IAAA,kCA8MA;IA9MA,6BA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,mCA8MA;EAAA;EA9MA;IAAA,mCA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,gCA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,0BA8MA;EAAA;EA9MA;IAAA,0BA8MA;EAAA;EA9MA;IAAA,0BA8MA;EAAA;EA9MA;IAAA,0BA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,+DA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,kCA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,oCA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,+DA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,+DA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,+DA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,+DA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,6BA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,4CA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,4CA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,mCA8MA;EAAA;EA9MA;IAAA,iCA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,0CA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,qBA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,yCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,yCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,gDA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,qCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,wCA8MA;EAAA;EA9MA;IAAA,mDA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,iDA8MA;EAAA;EA9MA;IAAA,sCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,uCA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,gBA8MA;EAAA;EA9MA;IAAA,iBA8MA;EAAA;EA9MA;IAAA,2BA8MA;IA9MA,6DA8MA;EAAA;EA9MA;IAAA,yBA8MA;IA9MA,2DA8MA;EAAA;EA9MA;IAAA,yBA8MA;IA9MA,2DA8MA;EAAA;EA9MA;IAAA,yBA8MA;IA9MA,2DA8MA;EAAA;EA9MA;IAAA,oCA8MA;IA9MA,sEA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,eA8MA;EAAA;EA9MA;IAAA,sCA8MA;IA9MA,qCA8MA;EAAA;EA9MA;IAAA,eA8MA;IA9MA,cA8MA;EAAA;EA9MA;IAAA,kBA8MA;IA9MA,iBA8MA;EAAA;EA9MA;IAAA,yCA8MA;IA9MA,oCA8MA;EAAA;EA9MA;IAAA,oDA8MA;IA9MA,+CA8MA;EAAA;EA9MA;IAAA,2CA8MA;IA9MA,sCA8MA;EAAA;EA9MA;IAAA,2CA8MA;IA9MA,sCA8MA;EAAA;EA9MA;IAAA,sDA8MA;IA9MA,iDA8MA;EAAA;EA9MA;IAAA,6CA8MA;IA9MA,wCA8MA;EAAA;EA9MA;IAAA,mCA8MA;IA9MA,oCA8MA;EAAA;EA9MA;IAAA,iBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,uBA8MA;EAAA;EA9MA;IAAA,8BA8MA;EAAA;EA9MA;IAAA,mBA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,4BA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,2BA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,cA8MA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,sBA8MA;EAAA;EA9MA;IAAA,0BA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,oBA8MA;EAAA;EA9MA;IAAA,yBA8MA;EAAA;EA9MA;IAAA,kBA8MA;EAAA;EA9MA;IAAA,0BA8MA;EAAA;EA9MA;IAAA,+BA8MA;EAAA;EA9MA;IAAA,yCA8MA;EAAA;EA9MA;IAAA;MAAA,4BA8MA;IAAA;IA9MA;MAAA,4BA8MA;IAAA;EAAA;EA9MA;IAAA,WA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,YA8MA;EAAA;EA9MA;IAAA,aA8MA;EAAA;EA9MA;IAAA,oFA8MA;IA9MA,sIA8MA;EAAA;EA9MA;IAAA,+DA8MA;IA9MA,sIA8MA;EAAA;EA9MA;IAAA,0EA8MA;IA9MA,iJA8MA;EAAA;EA9MA;IAAA,gIA8MA;IA9MA,sIA8MA;EAAA;EA9MA;IAAA,wHA8MA;IA9MA,sIA8MA;EAAA;EA9MA;IAAA,wHA8MA;IA9MA,sIA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,wBA8MA;EAAA;EA9MA;IAAA,oBA8MA;IA9MA,0LA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,0LA8MA;EAAA;EA9MA;IAAA,8BA8MA;IA9MA,0LA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,0LA8MA;EAAA;EA9MA;IAAA,yBA8MA;IA9MA,0LA8MA;EAAA;EA9MA;IAAA,0LA8MA;EAAA;EA9MA;IAAA,0PA8MA;IA9MA,qFA8MA;IA9MA,2EA8MA;EAAA;EA9MA;IAAA,2BA8MA;IA9MA,qFA8MA;IA9MA,2EA8MA;EAAA;EA9MA;IAAA,4BA8MA;IA9MA,qFA8MA;IA9MA,2EA8MA;EAAA;EA9MA;IAAA,0BA8MA;IA9MA,qFA8MA;IA9MA,2EA8MA;EAAA;EA9MA;IAAA,wBA8MA;IA9MA,qFA8MA;IA9MA,2EA8MA;EAAA;EA9MA;IAAA,mCA8MA;IA9MA,gGA8MA;IA9MA,sFA8MA;EAAA;EA9MA;IAAA,4BA8MA;IA9MA,qFA8MA;IA9MA,2EA8MA;EAAA;EA9MA;IAAA,wDA8MA;IA9MA,qFA8MA;IA9MA,2EA8MA;EAAA;EA9MA;IAAA,mBA8MA;IA9MA,yBA8MA;EAAA;EA9MA;IAAA,oBA8MA;IA9MA,0BA8MA;EAAA;EA9MA;IAAA,oBA8MA;IA9MA,0BA8MA;EAAA;EA9MA;IAAA,oBA8MA;IA9MA,0BA8MA;EAAA;EA9MA;IAAA,oBA8MA;IA9MA,0BA8MA;EAAA;EA9MA;IAAA,+BA8MA;IA9MA,qCA8MA;EAAA;EA9MA;IAAA,yBA8MA;IA9MA,0CA8MA;EAAA;EA9MA;IAAA,6BA8MA;IA9MA,8CA8MA;EAAA;EA9MA;IAAA,0BA8MA;IA9MA,2CA8MA;EAAA;EA9MA;IAAA,wBA8MA;IA9MA,mBA8MA;EAAA;EA9MA;IAAA,wBA8MA;IA9MA,qBA8MA;SA9MA,gBA8MA;EAAA;EA9MA;IAAA,yBA8MA;IA9MA,sBA8MA;SA9MA,iBA8MA;EAAA;EA9MA;IAAA;MAAA;QAAA,aA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA,wCA8MA;MA9MA,2CA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,0CA8MA;MA9MA,uBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,sCA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,yCA8MA;MA9MA,4CA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,yCA8MA;MA9MA,sBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,yBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,yBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,yBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,yBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,qBA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,mCA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,yBA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,uCA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,6BA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,WA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,4BA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,4BA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA,6HA8MA;QA9MA,sIA8MA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA,mCA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,wHA8MA;MA9MA,sIA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,wBA8MA;MA9MA,mBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,cA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA;QAAA;UAAA,8BA8MA;QAAA;MAAA;IAAA;EAAA;EA9MA;IAAA;MAAA,wBA8MA;IAAA;EAAA;EA9MA;IAAA;MAAA,wBA8MA;IAAA;EAAA;AAAA;AA9MA;EAAA;IAAA,sCA8MA;EAAA;AAAA;AA9MA;EAAA,kBA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,kBA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,yBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,yBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,yBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,uBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,uBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,gBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,oBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,wBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,sBA8MA;EA9MA,eA8MA;EA9MA,mBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,wBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,sBA8MA;EA9MA,eA8MA;EA9MA,mBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,wBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,wBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,kBA8MA;EA9MA,eA8MA;EA9MA,kBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,mBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;EA9MA,wBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,sBA8MA;EA9MA,eA8MA;EA9MA,mBA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA,WA8MA;EA9MA,eA8MA;AAAA;AA9MA;EAAA;IAAA,YA8MA;EAAA;AAAA;AA9MA;EAAA;;IAAA,wBA8MA;EAAA;EA9MA;;;;;IAAA,2BA8MA;EAAA;EA9MA;;;;IAAA,0BA8MA;EAAA;AAAA;AA9MA;EAAA;IAAA;MAAA,wBA8MA;MA9MA,wBA8MA;MA9MA,mBA8MA;MA9MA,mBA8MA;MA9MA,mBA8MA;MA9MA,eA8MA;MA9MA,eA8MA;MA9MA,eA8MA;MA9MA,yBA8MA;MA9MA,yBA8MA;MA9MA,yBA8MA;MA9MA,qBA8MA;MA9MA,qBA8MA;MA9MA,uBA8MA;MA9MA,wBA8MA;MA9MA,qBA8MA;MA9MA,yBA8MA;MA9MA,sBA8MA;MA9MA,sBA8MA;MA9MA,0BA8MA;MA9MA,uBA8MA;MA9MA,4BA8MA;MA9MA,gCA8MA;MA9MA,6BA8MA;MA9MA,wBA8MA;MA9MA,2BA8MA;MA9MA,8BA8MA;MA9MA,iCA8MA;MA9MA,wBA8MA;MA9MA,2BA8MA;MA9MA,4BA8MA;MA9MA,kCA8MA;MA9MA,kBA8MA;MA9MA,wBA8MA;MA9MA,sBA8MA;MA9MA,uBA8MA;MA9MA,wBA8MA;MA9MA,oBA8MA;MA9MA,qBA8MA;MA9MA,sBA8MA;MA9MA,mBA8MA;MA9MA,yBA8MA;MA9MA,+BA8MA;MA9MA,4BA8MA;MA9MA,8BA8MA;MA9MA,sBA8MA;MA9MA,kBA8MA;IAAA;EAAA;AAAA","sourcesContent":["@layer theme, base, components, utilities;\n\n@import 'tailwindcss/theme.css' layer(theme);\n@import 'tailwindcss/utilities.css' layer(utilities);\n\n@theme inline {\n  --color-navy: #303842;\n  --color-chathams-blue: #2c596d;\n  --color-blue-whale: #102128;\n  --color-light-slate-grey: #75879f;\n  --color-summer-sky: #19a9ed;\n  --color-mango-tango: #e57208;\n  --color-denim: #1485ba;\n  --color-white: #fff;\n  --color-black: #000;\n  --color-solitude: #f8f9fa;\n  --color-zircon: #f0f1f1;\n  --color-licorice: #303e4c;\n  --color-cinnabar: #e35837;\n  --color-spun-pearl: #ababad;\n  --color-alice-blue: #e4f5fd;\n  --color-islamic-green: #249903;\n  --color-persian-red: #d62d2d;\n  --color-moon-yellow: #f1c40f;\n  --color-saffron: #f6b93b;\n  --color-white-smoke: #efefef;\n  --color-deep-sea: #0f9d58;\n  --color-saffron-2: #f7c32d;\n  --color-boston-blue: #40a3a3;\n  --color-storm-grey: #7e7e80;\n  --color-gainsboro: #dedede;\n  --color-acadia: #566166;\n  --color-dark-grey: #2c3133;\n  --color-medium-grey: #818e94;\n  --color-brilliant-green: #75d052;\n  --color-vermilion-red: #f54c26;\n  --color-red: #f54c26;\n  --color-green: #75d052;\n  --color-blue: #29abe2;\n  --color-dark-blue: #2e3192;\n  --color-titan-white: #ebecfe;\n  --color-hawkes-blue: #dee0fc;\n  --color-jacksons-purple: #2e3487;\n  --color-scampi: #6269a6;\n  --color-slightly-darker-blue: #272a80;\n  --color-darker-blue: #202266;\n  --color-text-grey: #566166;\n  --color-disabled-grey: #818e94;\n  --color-light-grey-secondary: #f3f4f6;\n  --color-grey: #c6cdd0;\n  --color-light-grey: #eaebf0;\n  --color-app-container-color: #eef3f6;\n  --color-orange: #ffa500;\n  --color-light-blue: rgba(41, 171, 226, 0.1);\n  --color-very-light-blue: rgba(41, 171, 226, 0.06);\n  --color-very-light-blue-hover: rgba(41, 171, 226, 0.15);\n  --color-disabled-blue: var(--color-light-blue);\n  --color-catskill-white: #e9eef6;\n  --color-active-text: #2c3133;\n  --color-active-blue: var(--color-blue);\n  --color-hover-blue: var(--color-catskill-white);\n  --color-menu-text-item: var(--color-dark-grey);\n  --color-gray-chateau: #a8abae;\n  --color-geyser: #dfe3e8;\n  --color-bright-sun: #ffe342;\n  --color-astral: #337ab7;\n  --color-gallery: #ebebeb;\n  --color-mine-shaft: #393939;\n  --color-scorpion: #5e5e5e;\n  --color-athens-gray: #eaecef;\n  --color-shuttle-gray: #586165;\n  --color-shuttle-gray2: #566166;\n  --color-separator-color: rgba(171, 180, 192, 0.2);\n  --color-loblolly: #c7cdd0;\n  --color-havelock-blue: #52aadd;\n  --color-oslo-gray: #7f888a;\n  --color-oslo-gray2: #818e94;\n  --color-finlandia: #566156;\n  --color-outer-space: #2c3133;\n  --color-picton-blue: #4ba8e7;\n  --color-silver-chalice: #a1a1a1;\n  --color-cadet-blue: #adb4bf;\n  --color-matterhorn: #413238;\n  --color-alto: #dfdfdf;\n  --color-cod-gray: #0b0b0b;\n  --color-link-water: #dae9f3;\n  --color-emperor: #525252;\n  --color-iron: #e4e5e7;\n  --color-iron2: #dfe0e4;\n  --color-dove-gray: #6c6c6c;\n  --color-boulder: #7d7d7d;\n  --color-polar: #eef6fc;\n  --color-alabaster: #fbfbfb;\n  --color-silver-sand: #cccdcd;\n  --color-mantis: #8bcd63;\n  --color-hit-gray: #9dabb0;\n  --color-chateau-green: #48a75f;\n  --color-bombay: #b1b6b9;\n  --color-bombay2: #b0b3bf;\n  --color-bay-of-many: #2d348d;\n  --color-heather: #c4d0db;\n  --color-red-damask: #d57737;\n  --color-almond: #f0dccf;\n  --color-mid-gray: #656566;\n  --color-sail: #add5f9;\n  --color-tundora: #454545;\n  --color-black-squeeze: #f4f8fb;\n  --color-silver: #cacaca;\n  --color-mercury: #e6e6e6;\n  --color-cape-cod: #505151;\n  --color-link-water2: #dae9f3;\n  --color-foam: #f1fbfe;\n  --color-ochre: #c97c21;\n  --color-serenade: #fff5ea;\n  --color-porcelain: #edeff0;\n  --color-tequila: #ffe7cc;\n  --color-fantasy: #fbf8f4;\n  --color-carrot-orange: #ef942a;\n  --color-chelsea-gem: #9d5500;\n  --color-curious-blue: #29abe2;\n  --color-carla: #efffd6;\n  --color-costa-del-sol: #566d2f;\n  --color-killarney: #2f6d3e;\n  --color-snowy-mint: #d6ffe0;\n  --color-old-brick: #961919;\n  --color-cosmos: #ffd6d6;\n  --color-hint-of-green: #e9ffee;\n  --color-chablis: #fff0f0;\n  --color-spring-sun: #f4ffe3;\n  --color-aluminium: #a8aaad;\n  --color-blue-chalk: #f0eaff;\n  --color-blue-chalk-accentuated: #f0d1ff;\n  --color-buttercup: #edae0d;\n  --color-fog: #d6d9ff;\n  --color-california: #ff9800;\n  --color-rolling-stone: #71777a;\n  --color-flush-mahogany: #d14646;\n  --color-selago: #ecebfb;\n  --color-medium-purple: #7d57dd;\n  --color-bridal-heath: #fff8f1;\n  --color-hot-cinnamon: #e26f29;\n  --color-wild-sand: #f4f3f3;\n\n  /* Purple colors */\n  --color-purple-700: #4c26ab;\n  --color-purple-500: #7d57dd;\n  --color-purple-300: #b89cfd;\n  --color-purple-200: #dcceff;\n  --color-purple-100: #f0eaff;\n  --color-purple-50: #f7f4fb;\n  --color-amethyst: #a146d3;\n\n  /* metrics */\n  --spacing-sidebar-closed-width: 48px;\n  --spacing-sidebar-opened-width: 230px;\n  --spacing-navbar-height: 60px;\n  --spacing-screen-navbar-height: calc(100vh - var(--spacing-navbar-height));\n  --spacing-screen-chabot-height: calc(100vh - var(--spacing-navbar-height) - 64px);\n\n  /* Shadows */\n  --shadow-popup: 0px 1px 10px 0px #00000040;\n\n  /* Animations */\n  @keyframes shake {\n    0%,\n    100% {\n      transform: translateX(0);\n    }\n\n    10%,\n    30%,\n    50%,\n    70%,\n    90% {\n      transform: translateX(-4px);\n    }\n\n    20%,\n    40%,\n    60%,\n    80% {\n      transform: translateX(4px);\n    }\n  }\n\n  @keyframes star-blink {\n    0%,\n    49% {\n      opacity: 0;\n    }\n\n    50%,\n    100% {\n      opacity: 1;\n    }\n  }\n\n  --animate-shake: shake 0.5s;\n  --animate-star-blink: star-blink 1.8s step-end infinite;\n}\n\n@layer base {\n  * {\n    font-family: 'Avenir Next', sans-serif;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
